import React, { FC } from "react";
import { useFormState } from "react-final-form";
import { makeStyles, Typography } from "@material-ui/core";
import ApplicationsCount from "../../../components/ApplicationsCount/ApplicationsCount";

const useStyles = makeStyles(() => ({
  mainText: {
    fontWeight: "bold",
    marginBottom: 16,
  },
}));

interface DeactivateFormProps {
  name: string;
}

const DeleteContent: FC<DeactivateFormProps> = ({ name }) => {
  const classes = useStyles();
  const {
    values: {
      injectedData: { approved, pending },
    },
  } = useFormState();
  const isActive = approved + pending > 0;

  return (
    <div>
      {isActive ? (
        <>
          <Typography className={classes.mainText}>
            To delete this {name}, first you need to deactivate it
          </Typography>
          <ApplicationsCount
            name={name}
            approved={approved}
            pending={pending}
          />
        </>
      ) : (
        <Typography>Are you sure you want to delete this {name}?</Typography>
      )}
    </div>
  );
};

export default DeleteContent;
